import styled from "styled-components";
export const LocationWrapper = styled.div`
  background-color: #fff;
`;
